import { callDecimal, DecimalResult } from "../utils.ts";
import { AccessCode } from "../common-types/manageAssets.ts";

export async function getAccessCode(vbid: string) {
  const path = `/api/v1/access_codes/${vbid}`;
  return callDecimal<AccessCode>(path);
}

export async function redeemAccessCode(
  vbid: string
): Promise<DecimalResult<AccessCode>> {
  return callDecimal<AccessCode>(`/api/v1/access_codes/${vbid}/redeem`, {
    method: "POST",
  });
}
